import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/lib/font.ts\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"mont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(user-page)/AppStatus.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(user-page)/components/googletag/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RootProviders"] */ "/app/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/App.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
